import { SIGNUS_API_URL } from './constants';
import { fetchWithTokenRefresh } from './apiFetch';

export interface TemplateItem {
  id: string;
  name: string;
}

export async function fetchTemplateDocxContent(
  teamSlug: string,
  templateId: string,
  accessToken: string,
): Promise<Blob> {
  const url = `${SIGNUS_API_URL}/v0/teams/${encodeURIComponent(teamSlug)}/configure/templates/${encodeURIComponent(templateId)}/files/docx/content`;

  const res = await fetchWithTokenRefresh(url, accessToken, token => ({
    headers: { Authorization: token },
  }));

  if (!res.ok) {
    throw new Error(`Failed to fetch template content: ${res.status} ${res.statusText}`);
  }

  return res.blob();
}

interface PageablePayload<T> {
  thisPageItems: T[];
  totalNumber: number;
  lastPageIndex: number;
}

export async function fetchRootTemplates(
  teamSlug: string,
  accessToken: string,
): Promise<TemplateItem[]> {
  const url = `${SIGNUS_API_URL}/v0/teams/${encodeURIComponent(teamSlug)}/templates/folders/root?pageIndex=0&pageSize=100&sortBy=DATE_CREATED&sortOrder=DESC`;

  const res = await fetchWithTokenRefresh(url, accessToken, token => ({
    headers: { Authorization: token },
  }));

  if (!res.ok) {
    throw new Error(`Failed to fetch templates: ${res.status} ${res.statusText}`);
  }

  const json: { payload: PageablePayload<TemplateItem> } = await res.json();
  return json.payload.thisPageItems;
}
